module.exports = __webpack_public_path__ + "static/media/slide1Inactive.c8f51335.png";